module.exports = __webpack_public_path__ + "img/jbgqrcode.b770f9dd.jpg";